import BaseUpdateRequest from '@/models/Shared/BaseUpdateRequest';

export default class UpdateLocationPayrollSystemSettingsRequest extends BaseUpdateRequest {
    externalPayrollSystemId = '';
}
